<template>
  <div>
    <PageHeader :items="items" :optionalItems="optionalItems">
      <template #filters>
        <div class="search-filters">
          <SearchFilter :isFilterSearch="false">
            <li>
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("company") }}
                </label>
                <MultiSelectInput
                  v-model="form.company_id"
                  :options="customers"
                  :query="{ isMultiSelect: true }"
                  label="companyName"
                  trackBy="id"
                  moduleName="customers"
                  :multiple="false"
                  ><template #option="{ props }">
                    <div>
                      <p>
                        {{ props.option.companyNumber }} -
                        {{ props.option.companyName }}
                      </p>
                    </div>
                  </template>
                </MultiSelectInput>
              </div>
              <div class="form-group mt-1">
                <label class="input-label form-label"
                  >{{ $t("showAssignedUsers") }}
                </label>
                <div class="switch-container">
                  <label :class="['switch', toggleState ? 'on' : 'off']">
                    <input type="checkbox" v-model="toggleState" />
                    <span class="slider">
                      <span class="label">{{ toggleState ? "✓" : "✕" }}</span>
                    </span>
                  </label>
                </div>
              </div>
            </li>
          </SearchFilter>
          <div class="page-header-search">
            <input
              autocomplete="off"
              type="text"
              name="search"
              :placeholder="$t('search')"
              v-model="form.search_string"
            />
            <button class="" type="button" @click="resetFilter">
              {{ $t("reset") }}
            </button>
          </div>
        </div>
      </template>
    </PageHeader>

    <!--==================================-->
    <!--==================================-->
    <div class="dextop-table-view">
      <!-- table -->
      <div class="table-responsive api-keys-table users-list-table">
        <vue-good-table
          styleClass="vgt-table striped"
          :columns="columns"
          :fixed-header="false"
          :rows="modifiedUsers"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
            trigger: 'enter',
          }"
          :pagination-options="{
            enabled: false,
            perPage: pageLength,
          }"
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-per-page-change="onPerPageChange"
        >
          <template slot="table-row" slot-scope="props">
            <!-- Column: Name -->
            <div v-if="props.column.field === 'name'" class="px-auto">
              <span>{{
                props.row.first_name + " " + props.row.last_name
              }}</span>
            </div>
            <span v-else-if="props.column.field === 'lastLogin'">
              {{ props.row.lastLogin && props.row.lastLogin.date ? formatLastLoginDate(props.row.lastLogin.date) : '' }}
            </span>
            <span v-else-if="props.column.field === 'roles'">
              <multiselect
                :disabled="!$can('update-user')"
                v-model="props.row.roles"
                label="title"
                @select="assignRoles($event, props.row.roles, props.row.id)"
                @remove="removeRoles($event, props.row.roles, props.row.id)"
                track-by="id"
                :options="roles"
                :multiple="true"
              >
              </multiselect>
            </span>

            <!-- Column: Action -->
            <span v-else-if="props.column.field === 'action'">
              <feather-icon
                v-if="$can('list-users')"
                @click="$router.push(`/users/${props.row.id}/show`)"
                size="16"
                icon="EyeIcon"
                class="mr-50 cursor-pointer"
              />
              <feather-icon
                v-if="$can('update-user')"
                @click="$router.push(`/users/${props.row.id}/edit`)"
                size="16"
                icon="Edit2Icon"
                class="mr-50 cursor-pointer"
              />
              <feather-icon
                v-if="$can('delete-user')"
                @click="destroy(props.row.id)"
                size="16"
                icon="TrashIcon"
                class="mr-50 cursor-pointer"
              />
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-5">
        <b-form-group>
          <div class="d-flex align-items-center">
            <span class="text-nowrap"> {{ $t("rowsPerPage") }} </span>
            <b-form-select
              v-model="pageLength"
              :options="['25', '50', '100']"
              class="ml-1"
              @input="(value) => onPerPageChange({ pageLength: value })"
            />
          </div>
        </b-form-group>
        <div>
          <b-pagination
            :value="1"
            :total-rows="totalRecords"
            :per-page="pageLength"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @input="(value) => onPageChange({ currentPage: value })"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </div>
    </div>
    <!--==================================-->
    <!--==================================-->
    <div class="reponsive-view-cards">
      <div class="row">
        <div class="col-md-4" v-for="user in modifiedUsers" :key="user.id">
          <div class="card mb-1">
            <div class="card-header">
              <h4 class="">{{ user.first_name }} {{ user.last_name }}</h4>
              <div class="d-flex gap-2">
                <feather-icon
                  class="cursor-pointer"
                  v-if="$can('update-user')"
                  @click="$router.push(`/users/${user.id}/edit`)"
                  size="18"
                  icon="Edit2Icon"
                />
                <feather-icon
                  class="cursor-pointer"
                  v-if="$can('delete-user')"
                  @click="destroy(user.id)"
                  size="18"
                  icon="TrashIcon"
                />
              </div>
            </div>
            <div class="card-body">
              <ul class="card-list">
                <li>
                  <div class="left">
                    <strong>{{ $t("email") }}</strong>
                  </div>
                  <div class="right">
                    <p>{{ user.email }}</p>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("city") }}</strong>
                  </div>
                  <div class="right">
                    <p>{{ user.city }}</p>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("company") }}</strong>
                  </div>
                  <div class="right">
                    <p>{{ user.companyName }}</p>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("roles") }}</strong>
                  </div>
                  <div class="right">
                    <multiselect
                      :disabled="!$can('update-user')"
                      v-model="user.roles"
                      label="title"
                      @select="assignRoles($event, user.roles, user.id)"
                      @remove="removeRoles($event, user.roles, user.id)"
                      track-by="id"
                      :options="roles"
                      :multiple="true"
                    />
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("lastLogin") }}</strong>
                  </div>
                  <div class="right">
                    <p>{{ user.lastLogin && user.lastLogin.date ? formatLastLoginDate(user.lastLogin.date) : '' }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-2">
        <b-pagination
          :value="1"
          :total-rows="totalRecords"
          :per-page="pageLength"
          first-number
          last-number
          align="right"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
          @input="(value) => onPageChange({ currentPage: value })"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </div>
    <!--====================================-->
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { debounce } from "@/utils/debounce";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import SearchFilter from "@/components/SearchFilter.vue";
import MultiSelectInput from "@/components/MultiSelectInput.vue";

export default {
  components: {
    PageHeader,
    Multiselect,
    SearchFilter,
    MultiSelectInput,
  },
  computed: {
    ...mapGetters("roles", ["roles"]),
    ...mapGetters("customers", ["customers"]),
    modifiedUsers() {
      return this.filteredRows.map((row) => {
        return {
          ...row,
          companyName:
            this.customers.find((customer) => customer.id === row.company_id)
              ?.companyName || "",
          roles: row.roles
            .map((roleId) => {
              return {
                ...(this.roles?.find((role) => role.id == roleId) ?? {}),
              };
            })
            .filter((role) => role.id),
          lastLogin: row.last_login || null,
        };            
      });
    },
    filteredRows() {
      if (this.toggleState) {
        return this.rows.filter(
          (row) => row.company_id !== null && row.company_id !== ""
        );
      }
      return this.rows;
    },
    columns() {
      return [
        {
          label: this.$t("name"),
          field: "name",
          sortable: false,
        },
        {
          label: this.$t("email"),
          field: "email",
          sortable: false,
        },
        {
          label: this.$t("company"),
          field: "companyName",
          sortable: false,
        },
        {
          label: this.$t("city"),
          field: "city",
          sortable: false,
        },
        {
          label: this.$t("roles"),
          field: "roles",
          sortable: false,
        },
        {
          label: this.$t("lastLogin"),
          field: "lastLogin",
          sortable: false,
          width: "150px",
        },
        {
          tdClass: "vgt-center-align",
          thClass: "vgt-center-align white-color",
          label: this.$t("action"),
          field: "action",
          sortable: false,
        },
      ];
    },
    items() {
      return [
        {
          text: this.$t("dentalTwin"),
          to: "/home",
        },
        {
          text: this.$t("users"),
          active: true,
        },
      ];
    },
    optionalItems() {
      return {
        createBtn1: {
          show: true,
          text: this.$t("createUser"),
          icon: "PlusIcon",
          path: "/users/create",
          permission: "create-user",
        },
      };
    },
  },
  data() {
    return {
      totalRecords: 0,
      pageLength: 50,
      page: 1,
      toggleState: false,
      rows: [],
      searchTerm: "",
      form: {
        search_string: "",
        company_id: "",
      },
    };
  },
  async created() {
    this.debouncedFetch = debounce(async (newValue, oldValue) => {
      try {
        await this.loadItems();
      } catch (e) {
        console.error(e);
      }
    }, 300);
  },
  watch: {
    form: {
      handler() {
        this.debouncedFetch();
      },
      deep: true,
    },
  },

  async mounted() {
    try {
      await this.$store.dispatch("roles/list", {
        limit_start: 0,
        limit_count: 100,
      });
      this.$store.dispatch("customers/list", {
        page: 1,
        perPage: 500,
        isMultiSelect: true,
      });
      await this.loadItems();
    } catch (e) {
      console.error("api error ___", e);
    }
  },

  methods: {
    formatLastLoginDate(dateString) {
      if (!dateString || dateString === null || dateString === undefined) return '';
      try {
        // Parse the UTC date string and convert to local time
        const date = new Date(dateString + ' UTC');
        return date.toLocaleDateString();
      } catch (error) {
        return dateString;
      }
    },
    truncateString(str, maxLength) {
      if (str.length > maxLength) {
        return str.substring(0, maxLength) + "...";
      } else {
        return str;
      }
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this, newProps);
    },
    onPageChange(params) {
      this.page = params.currentPage;
      console.log(this.page);
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ pageLength: params.pageLength });
      this.loadItems();
    },
    async assignRoles(event, roles, id) {
      let arr = [];
      arr.push(event.id);
      roles.forEach((role) => {
        arr.push(role.id);
      });
      const payload = {
        roles: arr,
      };
      await this.$store.dispatch("users/update", {
        id: id,
        roles: payload.roles,
      });
    },
    async removeRoles(event, roles, id) {
      let arr = [];
      roles.forEach((role) => {
        arr.push(role.id);
      });
      arr.pop(event.id);
      const payload = {
        roles: arr,
      };
      await this.$store.dispatch("users/update", {
        id: id,
        roles: payload.roles,
      });
    },

    onSortChange(params) {
      this.sortType = params[0].type;
      this.sortField = params[0].field;
      this.loadItems();
    },
    resetFilter() {
      this.form = {
        search_string: "",
        company_id: "",
      };
      this.toggleState = false;
    },
    // load items is what brings back the rows from server
    async loadItems() {
      try {
        this.$store.commit("showLoader", true);
        let response = await this.$store.dispatch("users/list", {
          ...this.form,
          company_id: this.form.company_id?.id ?? "",
          limit_start: this.pageLength * (this.page - 1),
          limit_count: this.pageLength,
        });
        this.rows = response?.data?.data;
        this.totalRecords = response?.data?.count;
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    async destroy(id) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToDeleteThisRecord"),
        subText: this.$t("yesDeleteIt"),
      });

      if (confirmed) {
        await this.$store.dispatch("users/destroy", {
          id: id,
        });
        this.loadItems();
      }
    },
  },
};
</script>

<style>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.switch-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 5px; /* optional for spacing */
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  background-color: #ccc;
  border-radius: 34px;
  height: 100%;
  width: 100%;
  transition: 0.4s;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 8px;
}

.label {
  color: white;
  font-weight: bold;
  font-size: 16px;
}

.switch.on .slider {
  background-color: #28a745; /* green */
  justify-content: flex-end;
}

.switch.off .slider {
  background-color: #dc3545; /* red */
  justify-content: flex-start;
}

.slider::before {
  content: "";
  height: 26px;
  width: 26px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  left: 4px;
  bottom: 4px;
  transition: 0.4s;
}

.switch.on .slider::before {
  transform: translateX(26px);
}
</style>
